import AsyncSelect from 'react-select/async';
import useModules from 'hooks/API/GET/useModules';
import { getRandomUid } from 'utilities/uuid.service';
import { useEffect, useState } from 'react';

function ModulesMultiSelect({ enableAPI, values, handleChange }) {
  const [modules, setModules] = useState([]);
  const [defaultModules, setDefaultModules] = useState([]);
  const { data, isLoading } = useModules({ enabled: enableAPI });
  const _id = getRandomUid();

  useEffect(() => {
    setModules(data?.data?.map((item) => ({ label: item.name, value: item.key })));

    return () => {};
  }, [data?.data]);

  useEffect(() => {
    setDefaultModules(values ?? []);
  }, [values]);

  return (
    <>
      <label htmlFor={_id}>Modules *</label>
      <AsyncSelect
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
          multiValue: (styles) => {
            return {
              ...styles,
              backgroundColor: '#fadbff',
            };
          },
        }}
        inputId={_id}
        isMulti
        cacheOptions
        isLoading={isLoading}
        onChange={handleChange}
        defaultOptions={modules}
        value={defaultModules}
      />
    </>
  );
}

ModulesMultiSelect.defaultProps = {
  values: [],
  handleChange: () => {},
};

export default ModulesMultiSelect;
